module.exports = __webpack_public_path__ + "img/TopMain_Mobile.0b108ab2.png";